/*
 * @Author: shannyHuang
 * @Date: 2022-06-15 11:36:37
 * @LastEditors:
 * @LastEditTime: 2022-08-04 15:28:01
 * @FilePath: /wemeet-web-activity/src/pages/create/mobile/TagInput/index.tsx
 */
/** 标签输入. 非业界常规的标签输入, 仅有输入/删除, 没有候选项供选择 */
import React, { useCallback, useState } from 'react';
import type { FC } from 'react';
import { message } from '@tencent/tea-component';
import './TagInput.scss';
import classNames from 'classnames';

const EMPTY_LIST: string[] = [];
const TagInput: FC<IProps> = ({ id, value = EMPTY_LIST, onChange, max = 5 }) => {
  const [val, setVal] = useState('');

  const confirm = useCallback(() => {
    if (value.includes(val)) {
      message.error({ content: '不能输入重复名称的标签' });
      return;
    }
    if (value.length >= max) {
      message.error({ content: `最多只能设置 ${max} 个标签` });

      return;
    }
    if (val.length > 6) {
      message.error({ content: '单个标签最长 6 个字' });
      return;
    }
    /* eslint-disable-next-line @typescript-eslint/no-unnecessary-type-assertion */
    onChange!([...value, val]);
    setVal('');
  }, [val, onChange, setVal, value]);

  const onKeyDown: React.KeyboardEventHandler<HTMLInputElement> = useCallback(
    (e) => {
      const val = e.currentTarget.value;
      if (val && e.key === 'Enter') {
        confirm();
      }
    },
    [value, max, confirm],
  );

  const onInputChange: React.ChangeEventHandler<HTMLInputElement> = useCallback((e) => {
    setVal(e.currentTarget.value);
  }, []);

  const remove: React.MouseEventHandler<HTMLDivElement> = useCallback(
    (e) => {
      const { txt } = e.currentTarget.dataset;
      onChange!(value.filter((v) => v !== txt));
    },
    [value],
  );

  return (
    <div className="tagInput">
      <div className="input">
        <input
          id={id}
          enterKeyHint="enter"
          value={val}
          onKeyDown={onKeyDown}
          onChange={onInputChange}
          placeholder="请输入标签(最多6个字符)"
          maxLength={6}
        />
        <i
          className={classNames('iconfont icon-gouxuan', { hide: val.length === 0 })}
          onClick={confirm}
        />
      </div>
      <div className="values">
        {value.map((txt) => (
          <div className="tag" onClick={remove} data-txt={txt} key={txt}>
            {txt}
          </div>
        ))}
        <div className="holder"></div>
        <div className="counter">
          {value.length}/{max}
        </div>
      </div>
    </div>
  );
};
TagInput.displayName = 'TagInput';

export default TagInput;

interface IProps {
  /** html id */
  id?: string;
  value?: string[];
  max?: number;
  onChange?(value: string[]): void;
}
